import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './GoogleMaps.css';
import React from 'react';
import { Map, Marker, GoogleApiWrapper as GoogleMap } from 'google-maps-react';
import { canUseDOM, get, hexToRgb } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
export var defaultMapState = {
  lat: 25.2048493,
  lng: 55.2707828,
  activeMarker: 0,
  markers: [{}]
};
export var googleMapDirectionLink = function googleMapDirectionLink(lat, lng) {
  return "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
};
var defaultMarker = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNC4xNjEiIGhlaWdodD0iNDMuMDY0IiB2aWV3Qm94PSIwIDAgMzQuMTYxIDQzLjA2NCI+DQogIDxnIGlkPSJub3VuX0xvY2F0aW9uXzMwMjAzNzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03Ni43NTggLTE5NC40NTgpIj4NCiAgICA8ZyBpZD0iRWxsaXBzZV8xMDMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2Ljc1OCAyMDMuOTYxKSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIGlkPSJHcm91cF81NyIgZGF0YS1uYW1lPSJHcm91cCA1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzYuNzU4IDE5NC40NTYpIj4NCiAgICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8xIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDEiIGQ9Ik0tNjQ0NC43OTItMTkwMi40M2ExLjYsMS42LDAsMCwxLTEuMTM4LS40NzEsOTcuMzcsOTcuMzcsMCwwLDEtMTAuNzEzLTEyLjMzM2MtMy40ODEtNS4wMzctNS4yMzMtOS42MjQtNS4zNTYtMTQuMDIxdi0uMDg0YTE2LjYxOSwxNi42MTksMCwwLDEsNC45NzgtMTEuMjkyLDE3LjEzOSwxNy4xMzksMCwwLDEsMTEuNzU3LTQuODYxYy4xMTgsMCwuMjM2LDAsLjM1NCwwYTE3LjUsMTcuNSwwLDAsMSwxMS44OTQsNC41NjcsMTUuNzQyLDE1Ljc0MiwwLDAsMSw1LjE3NiwxMS4ydi4wMWMuMDY5LDQuMzM0LTEuMjkyLDguNjE3LTQuMTYzLDEzLjA5M2E3OS40NzIsNzkuNDcyLDAsMCwxLTkuMDQ5LDEwLjkyNmwtLjA0NC4wNDdjLS44NzIuOTM0LTEuNjk1LDEuODE2LTIuNTA1LDIuNzA5YTEuNTkyLDEuNTkyLDAsMCwxLTEuMTUzLjUxMlptLjI5Mi0zMS41NjFhNC41LDQuNSwwLDAsMC00LjUsNC41LDQuNTA1LDQuNTA1LDAsMCwwLDQuNSw0LjUsNC41MDYsNC41MDYsMCwwLDAsNC41LTQuNUE0LjUsNC41LDAsMCwwLTY0NDQuNS0xOTMzLjk5MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0NjIgMTk0NS40OTcpIiBmaWxsPSIjMDA2N2I5Ii8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==';
var MapContainer = /*#__PURE__*/function (_React$Component) {
  function MapContainer(props) {
    var _this;
    _classCallCheck(this, MapContainer);
    _this = _callSuper(this, MapContainer, [props]);
    _this.primary = void 0;
    _this.primary_active = void 0;
    _this.activeMarker = -1;
    _this.mapRef = void 0;
    _this.setBound = function () {
      var mapState = _this.props.mapState;
      if (_this.props.google) {
        if (mapState.markers[0].lat && mapState.markers[0].lng) {
          var bounds = new _this.props.google.maps.LatLngBounds();
          mapState.markers.some(function (marker) {
            var lat = Number(marker.lat);
            var lng = Number(marker.lng);
            if (marker.centered) {
              bounds = new _this.props.google.maps.LatLngBounds();
              bounds.extend({
                lat: lat,
                lng: lng
              });
            } else bounds.extend({
              lat: lat,
              lng: lng
            });
            return marker.centered;
          });
          return bounds;
        }
      }
    };
    _this.onMouseOverMarker = function (index, markerProps, marker, _ref) {
      var domEvent = _ref.domEvent;
      var toggleColor = function toggleColor() {
        if (_this.primary !== _this.primary_active) {
          if (~icon.url.indexOf(_this.primary)) {
            icon.url = icon.url.replace(_this.primary, _this.primary_active);
            marker.setIcon(icon);
          } else {
            icon.url = icon.url.replace(_this.primary_active, _this.primary);
            marker.setIcon(icon);
          }
        }
      };
      if (_this.state.activeMarker === index) {
        return;
      } else if (_this.state.activeMarker === -1 && index === 0) {
        return;
      }
      var icon = marker.getIcon();
      if (domEvent.type === 'mouseover') {
        toggleColor();
        marker.setZIndex(30);
      } else if (domEvent.type === 'mouseout') {
        toggleColor();
        marker.setZIndex(index);
      }
    };
    _this.onMarkerCallback = function (index, maps, marker) {
      var analytics = _this.props.analytics;
      var map = maps.map;
      var _map$center = map.center,
        lng = _map$center.lng,
        lat = _map$center.lat;
      var center = {
        lng: lng(),
        lat: lat()
      };
      var center2 = {
        lng: marker.position.lng(),
        lat: marker.position.lat()
      };
      _this.props.isCenterOnMarkerClick && map.panTo(center2);
      _this.activeMarker = index;
      _this.props.markerCallback && _this.props.markerCallback(marker, _this.props.isCenterOnMarkerClick ? center2 : center, true);
      _this.setState({
        activeMarker: index,
        center: _this.props.isCenterOnMarkerClick ? center2 : center
      });
      if (analytics) {
        tealiumClickFunc(tealiumMergeClickData(analytics['analytics'], analytics['params']), analytics['text']);
      }
    };
    _this.mapReadyHandler = function () {
      var callback = _this.props.callback;
      callback(_this.mapRef);
      setTimeout(function () {
        var current = _this.mapRef.current && _this.mapRef.current;
        if (current) {
          var block = current.mapRef.current.querySelector('[role="region"]');
          if (block) {
            block.removeAttribute("aria-roledescription");
          }
        }
      }, 300);
    };
    var isColorBlind = canUseDOM ? Boolean(document.getElementsByClassName("contrast").length) : false;
    _this.state = {
      activeMarker: -1,
      maxZoom: 0,
      isColorBlind: isColorBlind
    };
    _this.mapRef = /*#__PURE__*/React.createRef();
    var primary = get(_this.props.theme, 'primary', '');
    var primary_active = get(_this.props.theme, 'primary_active', '');
    var style = {};
    if (typeof window !== 'undefined') {
      style = window.getComputedStyle(document.querySelector('html'));
    }
    if (~primary.indexOf('--')) {
      primary = style.getPropertyValue(primary);
    }
    if (~primary_active.indexOf('--')) {
      primary_active = style.getPropertyValue(primary_active);
    }
    if (canUseDOM && document.body.classList.contains('vdsite')) {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    } else if (!document.body.classList.contains('vdsite')) {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(0 144 154)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(17 94 103)';
    } else {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    }
    return _this;
  }
  _inherits(MapContainer, _React$Component);
  return _createClass(MapContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var current = this.mapRef.current && this.mapRef.current;
      // @ts-ignore
      var map = current.map;
      if (map && this.props.maxZoomActive) {
        var listener = google.maps.event.addListener(map, "idle", function () {
          _this2.setState({
            maxZoom: map.getZoom() + _this2.props.zoomedLevel
          });
          map.setOptions({
            maxZoom: map.getZoom() + _this2.props.zoomedLevel
          });
          google.maps.event.removeListener(listener);
        });
      }
    }
    // componentDidUpdate () {
    //   const current = this.mapRef.current && this.mapRef.current
    //   // @ts-ignore
    //   const map = current.map
    //   if(map && this.props.maxZoomActive) {
    //      const listener = google.maps.event.addListener(map, "idle", () => {
    //         const maxZoom = this.state.maxZoom || 0
    //         if(maxZoom !=0 && map.getZoom() > maxZoom )
    //           map.setZoom(this.state.maxZoom)
    //
    //         google.maps.event.removeListener(listener);
    //       });
    //
    //
    //   }
    //
    // }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var currentValueOfColorBlind = canUseDOM ? Boolean(document.getElementsByClassName("contrast").length) : false;
      if (nextState.isColorBlind !== currentValueOfColorBlind) {
        nextState.isColorBlind = currentValueOfColorBlind;
        return true;
      }
      var mapState = this.props.mapState;
      if (nextState.activeMarker == this.state.activeMarker && mapState === nextProps.mapState) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var mapState = _ref2.mapState;
      if (mapState.activeMarker !== this.state.activeMarker) {
        this.setState({
          activeMarker: mapState.activeMarker
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        zoom = _this$props.zoom,
        google = _this$props.google,
        mapState = _this$props.mapState,
        customMarker = _this$props.customMarker,
        disableBound = _this$props.disableBound,
        _this$props$allowZoom = _this$props.allowZoomControl,
        allowZoomControl = _this$props$allowZoom === void 0 ? true : _this$props$allowZoom,
        zoomChanged = _this$props.zoomChanged,
        _this$props$visible = _this$props.visible,
        visible = _this$props$visible === void 0 ? true : _this$props$visible;
      var options;
      var center = {};
      if (mapState.markers.length < 2 || disableBound) {
        options = {
          zoom: zoom,
          center: {
            lat: mapState.lat,
            lng: mapState.lng
          }
        };
        center = options.center;
      } else {
        var bounds = this.setBound();
        options = {
          bounds: bounds
        };
      }
      var onReady = function onReady() {
        return _this3.mapReadyHandler();
      };
      return /*#__PURE__*/React.createElement("div", {
        className: commonStyles
      }, /*#__PURE__*/React.createElement("div", {
        className: "googleMapId"
      }, /*#__PURE__*/React.createElement(Map, _extends({
        ref: this.mapRef,
        google: google
      }, options, {
        visible: visible,
        onReady: onReady,
        center: center,
        streetViewControl: false,
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: allowZoomControl,
        onZoomChanged: zoomChanged,
        fullscreenControl: false,
        keyboardShortcuts: false,
        initialCenter: {
          lat: mapState.lat,
          lng: mapState.lng
        }
      }), google && mapState.markers && mapState.markers.map(function (marker, index) {
        var isContrastMode = document.getElementsByClassName("contrast").length;
        var fillColorForMultiplePins = mapState.activeMarker === index || _this3.state.activeMarker == index ? isContrastMode ? "rgba(155, 155, 155)" : _this3.primary_active : _this3.primary;
        var fillColorForOnePin = _this3.state.activeMarker === -1 && mapState.activeMarker === index || _this3.state.activeMarker === index ? _this3.primary_active : _this3.primary;
        var lat = Number(marker.lat);
        var lng = Number(marker.lng);
        return /*#__PURE__*/React.createElement(Marker, {
          key: index,
          label: customMarker && mapState.markers.length > 1 ? {
            text: "".concat(index + 1),
            color: '#fff',
            fontSize: '1.125rem',
            fontWeight: "400"
          } : '',
          title: marker.title,
          icon: customMarker && mapState.markers.length > 1 ? {
            url: "data:image/svg+xml;utf-8, <svg width=\"40\" height=\"60\" viewBox=\"0 0 40 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.85786 6.15076C9.60859 2.21249 14.6957 0 20 0C25.3043 0 30.3914 2.21249 34.1421 6.15076C37.8929 10.089 40 15.4305 40 21C40 36.75 20 60 20 60C20 60 0 36.75 0 21C0 15.4305 2.10714 10.089 5.85786 6.15076Z\" fill=\"".concat(fillColorForMultiplePins, "\"/>\n                            </svg>"),
            //  anchor: new google.maps.Point(41, 60),
            scaledSize: new google.maps.Size(40, 60),
            labelOrigin: new google.maps.Point(20, 25)
          } : {
            url: "data:image/svg+xml;utf-8, <svg width=\"36\" height=\"50\" viewBox=\"0 0 36 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                 <path d=\"M18 23.75C16.3424 23.75 14.7527 23.0915 13.5806 21.9194C12.4085 20.7473 11.75 19.1576 11.75 17.5C11.75 15.8424 12.4085 14.2527 13.5806 13.0806C14.7527 11.9085 16.3424 11.25 18 11.25C19.6576 11.25 21.2473 11.9085 22.4194 13.0806C23.5915 14.2527 24.25 15.8424 24.25 17.5C24.25 18.3208 24.0883 19.1335 23.7742 19.8918C23.4602 20.6501 22.9998 21.3391 22.4194 21.9194C21.8391 22.4998 21.1501 22.9602 20.3918 23.2742C19.6335 23.5883 18.8208 23.75 18 23.75ZM18 0C13.3587 0 8.90752 1.84374 5.62563 5.12563C2.34374 8.40752 0.5 12.8587 0.5 17.5C0.5 30.625 18 50 18 50C18 50 35.5 30.625 35.5 17.5C35.5 12.8587 33.6563 8.40752 30.3744 5.12563C27.0925 1.84374 22.6413 0 18 0Z\" fill=\"".concat(fillColorForOnePin, "\"/>\n                                </svg>"),
            //  anchor: new google.maps.Point(34, 43),
            scaledSize: new google.maps.Size(35, 50)
          },
          onMouseout: _this3.onMouseOverMarker.bind(_this3, index),
          onClick: _this3.onMarkerCallback.bind(_this3, index),
          onMouseover: _this3.onMouseOverMarker.bind(_this3, index),
          position: {
            lat: lat,
            lng: lng
          },
          zIndex: index >= 0 && mapState.activeMarker === index || _this3.state.activeMarker == index ? mapState.markers.length + 1 : index
        });
      }))));
    }
  }]);
}(React.Component);
export default GoogleMap({
  apiKey: !process.env.STORYBOOK_MODE && canUseDOM ? get(window, 'map_key') : 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8',
  language: !process.env.STORYBOOK_MODE && canUseDOM ? get(window, 'current_language') : 'en'
})(MapContainer);
var commonStyles = "cjamj6l";